import { DevelopLogs } from "../widgets/developLogs/developLogs.js";

let fdDevelopLogs = document.getElementById('fdDevelopLogs');
let opts = {};
let fdDevelopLogsWidget = new DevelopLogs(fdDevelopLogs, opts);